import { i18n } from 'next-i18next'
import { TFunction } from 'react-i18next'
import { ident } from 'utils/general'
import { AnyNamespace } from 'utils/i18n/types'

export function getTranslation<T extends AnyNamespace>(_namespace: T): { t: TFunction<T> } {
  const i18nT = i18n?.t
  const t = i18nT
    ? ident<TFunction<AnyNamespace>>((key) => {
        const result = i18nT(key)
        if (result !== key) return result

        // for non-common namespace translations, it returns the translation key
        // I have no idea why and don't want to resolve it right now, so I've managed to come up with the below solution to the problem
        // IMPROVE find out what's going on and figure out a prettier solution
        const firstKey = String(Array.isArray(key) ? (key as string[])[0] : key)
        const namespace = firstKey.split('.')[0] ?? 'common'
        return i18n?.getResource(i18n.language, namespace, firstKey) ?? firstKey
      })
    : undefined
  return { t: t ?? ident }
}
